<template>
  <el-container>
    <el-container>
      <el-aside width="200px">
        <el-menu default-active="1-4-1" class="el-menu-vertical-demo" router>
          <!-- @open="handleOpen" -->
          <!-- @close="handleClose" -->
          <!-- :collapse="isCollapse" -->
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">问卷调查</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/feedback"> 问卷列表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span slot="title">留言管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/board">留言列表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main><router-view></router-view> </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {}
  },

  mounted() {},

  methods: {
    logout() {
      window.sessionStorage.clear('token')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.el-header {

  position: relative;
  padding: 0;
  img {
    position: absolute;
    right: 30px;

    width: 50px;
    height: 50px;
    border-radius: 50%;
    padding: 4px;

    top: 0;
  }
  .el-button {
    position: absolute;
    right: 130px;
    top: 10px;
  }
}
.el-container {
  height: 100%;
}
.el-aside {
  background-color: #fff;
}
.el-main {

}
</style>
